import { render, staticRenderFns } from "./video-create.vue?vue&type=template&id=232e3242&"
import script from "./video-create.vue?vue&type=script&lang=js&"
export * from "./video-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('232e3242', component.options)
    } else {
      api.reload('232e3242', component.options)
    }
    module.hot.accept("./video-create.vue?vue&type=template&id=232e3242&", function () {
      api.rerender('232e3242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/views/material/video-create.vue"
export default component.exports